
import { Link } from 'react-router-dom';

import {
    HiArrowLeft,
    HiArrowRight,
    HiBookOpen
} from 'react-icons/hi';

import blogPosts from '../../generated/blogPosts.json';

import {
    getBlogCategoryLabel
} from '../../data/blogCategories';


// Get available articles
const availablePosts = blogPosts.filter((post) => {
    if (!post.slug) return false;

    const hasEnglish =
        post.en?.title && post.en.enabled !== false;

    const hasPersian =
        post.fa?.title && post.fa.enabled !== false;

    return hasEnglish || hasPersian;
});


// Featured articles first
const selectedPosts = [
    ...availablePosts.filter((post) => post.featured),
    ...availablePosts.filter((post) => !post.featured)
].slice(0, 3);


function ArticleCard({ post }) {

    const language =
        post.en?.title && post.en.enabled !== false
            ? 'en'
            : 'fa';

    const content = post[language];

    const isPersian = language === 'fa';

    const category = getBlogCategoryLabel(
        post.category,
        language
    );

    return (
        <article className="h-full">

            <Link
                to={`/blog/${language}/${post.slug}`}
                className="group glass-light flex flex-col h-full overflow-hidden rounded-xl sm:rounded-2xl transition-all duration-300 hover:-translate-y-1"
            >

                {/* Article Cover */}
                <div className="h-44 sm:h-48 overflow-hidden bg-theme-primary">

                    {post.cover ? (
                        <img
                            src={post.cover}
                            alt={content.title}
                            loading="lazy"
                            decoding="async"
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                    ) : (
                        <div className="h-full flex items-center justify-center text-4xl text-primary-500">
                            H.
                        </div>
                    )}

                </div>


                {/* Article Content */}
                <div
                    className="p-5 sm:p-6 flex flex-col flex-1"
                    lang={language}
                    dir={isPersian ? 'rtl' : 'ltr'}
                >

                    <span className="text-primary-500 text-xs font-semibold">
                        {category}
                    </span>

                    <h3 className="mt-3 mb-3 text-lg sm:text-xl font-bold leading-relaxed text-theme-primary group-hover:text-primary-500 transition-colors">
                        {content.title}
                    </h3>

                    {content.description && (
                        <p className="text-theme-secondary text-sm leading-relaxed mb-5">
                            {content.description}
                        </p>
                    )}

                    <div className="mt-auto pt-3 flex items-center gap-2 text-primary-500 text-sm font-medium">

                        {isPersian
                            ? 'مطالعه مقاله'
                            : 'Read Article'}

                        {isPersian
                            ? <HiArrowLeft />
                            : <HiArrowRight />}

                    </div>

                </div>

            </Link>

        </article>
    );
}


function FeaturedWriting() {

    return (
        <section
            id="writing"
            className="relative py-16 sm:py-24 overflow-hidden"
        >

            <div className="absolute inset-0 bg-theme-secondary" />

            <div className="container mx-auto px-4 relative z-10">

                <div className="glass rounded-xl sm:rounded-2xl p-6 sm:p-10 lg:p-12">

                    {/* Section Header */}
                    <div className="mb-10">

                        <span className="inline-block px-3 py-1.5 rounded-full glass-light text-primary-500 text-xs font-medium mb-4">
                            Writing
                        </span>

                        <h2 className="text-3xl sm:text-4xl font-bold text-theme-primary mb-5">

                            Product Design Notes{' '}

                            <span className="gradient-text">
                                & Thinking
                            </span>

                        </h2>

                        <p className="text-theme-secondary leading-relaxed max-w-2xl">
                            Practical notes about user research,
                            problem framing, product thinking,
                            design systems, and the decisions
                            behind better digital products.
                        </p>

                    </div>


                    {/* Article Cards */}
                    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">

                        {selectedPosts.map((post) => (
                            <ArticleCard
                                key={post.slug}
                                post={post}
                            />
                        ))}

                    </div>


                    {/* View All Articles */}
                    <div className="mt-12 text-center">

                        <Link
                            to="/blog/fa"
                            className="btn-primary inline-flex items-center justify-center gap-2"
                        >

                            <HiBookOpen />

                            View All Articles

                            <HiArrowRight />

                        </Link>

                    </div>

                </div>

            </div>

        </section>
    );
}

export default FeaturedWriting;
